module.exports = __webpack_public_path__ + "img/emotion-design.e6a86bb.jpg";